import { Button as ButtonAura, cn } from '@bridebook/aura';
import { ComponentPropsWithoutRef, ElementRef, forwardRef } from 'react';

type Props = ComponentPropsWithoutRef<typeof ButtonAura>;

export const Button = forwardRef<ElementRef<typeof ButtonAura>, Props>(
  ({ children, className, ...props }, ref) => (
    <ButtonAura
      ref={ref}
      className={cn(
        'min-w-[280px] border-none bg-[var(--ww-palette-cta)]',
        'text-[var(--ww-palette-text-cta)]',
        'text-(length:--font-cta-size) @screen-lg:text-(length:--font-cta-size-desktop)',
        'font-[family-name:var(--font-cta-typeface)]',
        'font-(weight:--font-cta-weight)',
        'hover:bg-[var(--ww-palette-cta-hover)]',
        'active:bg-[var(--ww-palette-cta-active)]',
        'disabled:bg-[var(--ww-palette-cta-hover)]',
        className,
      )}
      {...props}>
      {children}
    </ButtonAura>
  ),
);

Button.displayName = 'Button';
